import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { SpinnerService } from '../../core/service/spinner.service';
import { BROADCAST_CHANNEL_NAME } from '../../core/component/sidenav/side-nav.component';
import { SpinnerType } from './spinner-types';

export const IS_SPINNER_ACTIVE = new HttpContextToken<boolean>(() => false);
export const SPINNER_TEXT = new HttpContextToken<string>(() => '');
export const SPINNER_TYPE = new HttpContextToken<SpinnerType>(() => SpinnerType.DEFAULT);

@Injectable()
export class LoadInterceptor implements HttpInterceptor {
  broadcaster = new BroadcastChannel(BROADCAST_CHANNEL_NAME);

  constructor(
    private spinner: SpinnerService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isSpinnerActive = request.context.get(IS_SPINNER_ACTIVE);
    const spinnerText = request.context.get(SPINNER_TEXT);
    const spinnerType = request.context.get(SPINNER_TYPE);

    if (isSpinnerActive) {
      this.spinner.addActiveRequest(spinnerText, spinnerType);
    }
    return this.handler(next, request, isSpinnerActive ? spinnerType : undefined);
  }

  /**
   * Sends the signal to all fms tabs, that they need to reset their logout counter.
   * After the response is handled, decrements the active spinner request counter.
   *
   * @param next is the stream of request events.
   * @param request is http request per se.
   * @param spinnerType is the type of spinner to remove when request completes.
   */
  handler(next: HttpHandler, request: HttpRequest<any>, spinnerType?: SpinnerType): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        // update the logout counter
        if (event instanceof HttpResponse && !event.url.includes('logout')) {
          this.broadcaster.postMessage('Oida schon wieder die GIS.');
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => throwError(error)),
      finalize(() => {
        this.spinner.removeActiveRequest(spinnerType);
      }),
    );
  }
}
